
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import SubRow from '../SubRow';

import "./styles.css";
import { connect } from "react-redux";
import { AngleDown, AngleRight } from 'theme/icon';
import moment from "moment-timezone";
import { getPortfolioRowClassName, toggleRowSelected } from 'utils/tableRowSelect';

const stylesLocal = {
    subcell: {
        padding: "5px",
    },
    cell: {
        padding: "5px",
    }
};

function findAtmBoundaryIndex(strikeList, spot) {
    if (!Array.isArray(strikeList) || !strikeList.length || !(spot > 0)) {
        return -1;
    }

    for (let i = 0; i < strikeList.length; i += 1) {
        const prev = i > 0 ? Number(strikeList[i - 1].strike_price) : Number.NEGATIVE_INFINITY;
        const curr = Number(strikeList[i].strike_price);
        if (Number.isFinite(prev) && Number.isFinite(curr) && prev < spot && curr >= spot) {
            return i;
        }
    }

    return -1;
}

function findAtmStrikeIndex(strikeList, spot) {
    if (!Array.isArray(strikeList) || !strikeList.length || !(spot > 0)) {
        return -1;
    }

    let bestIndex = 0;
    let bestDiff = Infinity;
    strikeList.forEach((item, index) => {
        const strike = Number(item.strike_price);
        if (!Number.isFinite(strike)) {
            return;
        }
        const diff = Math.abs(strike - spot);
        if (diff < bestDiff) {
            bestDiff = diff;
            bestIndex = index;
        }
    });
    return bestIndex;
}

const Row = props => {
    const { item, price } = props;
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(false);

    const spot = Number(price);
    const strikeList = useMemo(() => {
        const list = Array.isArray(item?.strike_list) ? [...item.strike_list] : [];
        return list.sort((a, b) => Number(a.strike_price) - Number(b.strike_price));
    }, [item?.strike_list]);

    const { atmBoundaryIndex, atmStrikeIndex } = useMemo(() => ({
        atmBoundaryIndex: findAtmBoundaryIndex(strikeList, spot),
        atmStrikeIndex: findAtmStrikeIndex(strikeList, spot),
    }), [strikeList, spot]);

    return (
        <React.Fragment>
            <tr
                className={getPortfolioRowClassName(selected)}
                onClick={(event) => toggleRowSelected(event, setSelected)}
            >
                <td style={{
                    padding: "5px",
                    fontWeight: "bold",
                }} align="left">
                    <span
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <AngleDown /> : <AngleRight />}
                    </span>
                    {props.item.expiration_date}
                </td>
                <td align="center" />
                <td style={{
                    padding: "5px",
                    fontWeight: "bold",
                    color: "black"
                }} align="right">
                    {"Call"}
                </td>
                <td style={stylesLocal.cell} align="right" />
                <td style={stylesLocal.cell} align="right" />
                <td style={{
                    padding: "5px",
                    fontWeight: "bold",
                    color: "black"
                }} align="center">
                    {moment.tz(props.item.expiration_date, "America/New_York").diff(moment().tz("America/New_York"), "days") + 1}{"d"}
                </td>
                <td style={stylesLocal.cell} align="right" />
                <td style={stylesLocal.cell} align="right" />
                <td style={{
                    padding: "5px",
                    fontWeight: "bold",
                    color: "black"
                }} align="right"> {"Put"}</td>
                <td style={{
                    padding: "5px",
                    fontWeight: "bold",
                    color: "black"
                }} align="right" />
                <td style={stylesLocal.cell} align="right" />
            </tr>
            {
                <div style={{ "display": open ? "contents" : "none" }}>
                    {
                        strikeList.map((subItem, index) => (
                            <SubRow
                                key={`${subItem.strike_price}-${index}`}
                                subItem={subItem}
                                name={props.name}
                                symbol={props.symbol}
                                isAtmBoundary={index === atmBoundaryIndex}
                                isAtm={index === atmStrikeIndex}
                                spotPrice={spot}
                            />
                        ))
                    }
                </div>
            }
        </React.Fragment>
    )
}

Row.propTypes = {
    className: PropTypes.string,
    item: PropTypes.object,
    price: PropTypes.number,
    name: PropTypes.string,
    symbol: PropTypes.string,
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        stock: reducer.event.stock,
        option: reducer.event.option,
        listOption: reducer.optionTrade.list,
    };
}

export default connect(mapStateToProps)(Row);
